// @flow
export { default } from './OfferTemplate';



// WEBPACK FOOTER //
// ./src/components/offer/OfferTemplate/index.js